import { string } from "../types/string";

export default function toUpperCase(a) {
  return string(a).toUpperCase();
}
